import { render, staticRenderFns } from "./d-empty.vue?vue&type=template&id=368eafa7&scoped=true"
import script from "./d-empty.vue?vue&type=script&lang=js"
export * from "./d-empty.vue?vue&type=script&lang=js"
import style0 from "./d-empty.vue?vue&type=style&index=0&id=368eafa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368eafa7",
  null
  
)

export default component.exports